<div class="trezo-card-title">
    <h6 class="!mb-3 text-left">
        Training Target Vs Achieved
    </h6>
</div>

<div>
    <!-- <div class="filters flex gap-3 mb-4">
        <mat-form-field appearance="outline">
            <mat-label>District</mat-label>
            <mat-select >
                <mat-option value="">Select District</mat-option>
                <mat-option value="101">Nadia</mat-option>
                <mat-option value="102">Jhargram</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Block</mat-label>
            <mat-select>
                <mat-option value="">Select Block</mat-option>
                <mat-option value="1001">Nadia</mat-option>
                <mat-option value="1002">Jhargram</mat-option>
            </mat-select>
        </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Session</mat-label>
        <mat-select >
            <mat-option value="">Select Financial Year</mat-option>
            <mat-option value="2025">2025-2026</mat-option>
            <mat-option value="2024">2024-2025</mat-option>
        </mat-select>
    </mat-form-field>
    </div> -->



  <!--ag-charts
        *ngIf="isBrowser && options"
        [options]="options" style="width: 100%; height: 400px; display: block"
    ></ag-charts-->
    <ag-charts
    *ngIf="isBrowser && options"
    [options]="options"
    style="width: 100%; height: 400px; display: block"
    ></ag-charts>
</div>